module.exports = __webpack_public_path__ + "static/media/archive.16bd0082.svg";